/** Criterios de la nota de salud de un servicio (acordados con el usuario 2026-10-20). */
export const MIN_COVERAGE = 90;

export type Measure = { metric: string; value: string };
export type Check = { label: string; pass?: boolean; detail: string };

// Sonar devuelve las calificaciones como 1.0 … 5.0 (A … E).
const RATINGS: [string, string][] = [
  ['reliability_rating', 'Fiabilidad'],
  ['security_rating', 'Seguridad'],
  ['sqale_rating', 'Mantenibilidad'],
  ['security_review_rating', 'Revisión de seguridad'],
];
const letter = (v?: string) => (v ? 'ABCDE'[Math.round(Number(v)) - 1] ?? '?' : undefined);

/** Nombre del repo de un proyecto Snyk ("org/repo(rama):package.json" → "repo"). */
export const snykRepo = (projectName: string) => projectName.split(/[(:]/)[0].split('/').pop() ?? '';

/** Checks de la nota: cobertura > 90 %, todas las calificaciones de Sonar en A y Snyk sin críticas ni altas. */
export function evaluate(measures: Measure[] | undefined, snyk: [number, number] | undefined): Check[] {
  const get = (metric: string) => measures?.find(m => m.metric === metric)?.value;
  const coverage = get('coverage');
  const ratings = RATINGS.map(([metric, name]) => [name, letter(get(metric))] as const).filter(([, l]) => l);
  const notA = ratings.filter(([, l]) => l !== 'A');
  let ratingsDetail = 'sin datos de Sonar';
  if (ratings.length) ratingsDetail = notA.length ? notA.map(([n, l]) => `${n} ${l}`).join(', ') : 'todo en A';
  return [
    {
      label: `Cobertura mayor a ${MIN_COVERAGE} %`,
      pass: coverage === undefined ? undefined : Number(coverage) > MIN_COVERAGE,
      detail: coverage === undefined ? 'sin datos de Sonar' : `${coverage} %`,
    },
    {
      label: 'Sonar: todas las calificaciones en A',
      pass: ratings.length ? !notA.length : undefined,
      detail: ratingsDetail,
    },
    {
      label: 'Snyk: sin vulnerabilidades críticas ni altas',
      pass: snyk ? snyk[0] + snyk[1] === 0 : undefined,
      detail: snyk ? `${snyk[0]} críticas, ${snyk[1]} altas` : 'sin proyecto en Snyk',
    },
  ];
}

/** Aprobado solo si pasan todos; sin datos si falta alguno y ninguno falla. */
export const verdict = (checks: Check[]): 'pass' | 'fail' | 'unknown' => {
  if (checks.some(c => c.pass === false)) return 'fail';
  return checks.every(c => c.pass) ? 'pass' : 'unknown';
};
